export const _init_weather_components = () => {
	return [
		{
			id: 1,
			cond: 'clouds',
			i18n: 'option_scene_weather_cond_clouds',
			options: ['clear_sky', 'partly_cloudy', 'mostly_cloudy', 'cloudy', 'overcast'],
			ui_operators: ['equal'],
		},
		{
			id: 2,
			cond: 'wind_direction',
			i18n: 'option_scene_weather_cond_wind_direction',
			options: [
				'north',
				'north_northeast',
				'northeast',
				'east_northeast',
				'east',
				'east_southeast',
				'southeast',
				'south_southeast',
				'south',
				'south_southwest',
				'southwest',
				'west_southwest',
				'west',
				'west_northwest',
				'northwest',
				'north_northwest',
			],
			ui_operators: ['equal'],
		},
		{
			id: 3,
			cond: 'wind_force',
			i18n: 'option_scene_weather_cond_wind_force',
			options: [
				'calm', //<1km/h
				'light_air', //1-5km/h
				'light_breeze', //6-11km/h
				'gentle_breeze', //12-19km/h
				'moderate_breeze', //20-28km/h
				'fresh_breeze', //29-38km/h
				'strong_breeze', //38-49km/h
				'near_gale', //50-61km/h
				'gale', //62-74km/h
				'strong_gale', //75-88km/h
				'storm', //89-102km/h
				'violent_storm', //103-117 km/h
				'hurricane', // 118+ km/h
			],
			ui_operators: ['equal'],
		},
		{
			id: 4,
			cond: 'wind_speed',
			i18n: 'option_scene_weather_cond_wind_speed',
			input: 0,
			ui_operators: ['less_than', 'more_than'],
		},
		// {
		// 	/**
		// 	 * 	500 - light rain
		// 		501 - moderate rain
		// 		502 - heavy intensity rain
		// 		503 - very heavy rain
		// 	 */
		// 	id: 4,
		// 	cond: 'rain',
		// 	i18n: 'opt_rain',
		// 	options: [
		// 		'light rain',
		// 		'moderate rain',
		// 		'heavy intensity rain',
		// 		'very heavy rain'
		// 	],
		// 	ui_operators: ['equal']
		// },
		// {
		// 	/**
		// 	 * 	600 - light snow
		// 		601 - Snow
		// 		602 - Heavy snow
		// 		615 - Light rain and snow
		// 		616 - Rain and snow
		// 	 */
		// 	id: 6,
		// 	cond: 'snow', //_ice',
		// 	i18n: 'opt_snow', //_ice',
		// 	options: [
		// 		'light snow',
		// 		'snow',
		// 		'heavy snow',
		// 		'light rain and snow',
		// 		'rain and snow'
		// 	],
		// 	ui_operators: ['equal']
		// },
		{
			id: 8,
			cond: 'chance_precipitation',
			i18n: 'option_scene_weather_cond_precipitation',
			ui_operators: ['less_than', 'more_than'],
			input: 0,
		},
		{
			id: 5,
			cond: 'temperature',
			i18n: 'option_scene_weather_cond_temperature',
			input: 0,
			ui_operators: ['less_than', 'more_than'],
		},
		{
			id: 6,
			cond: 'humidity',
			i18n: 'option_scene_weather_cond_humidity',
			input: 0,
			ui_operators: ['less_than', 'more_than'],
		},
		// {
		// 	id: 7,
		// 	cond: 'uv',
		// 	i18n: 'opt_uv_index',
		// 	input: 0,
		// 	ui_operators: ['less than', 'more than']
		// }
	];
};
